<div class="modal-content w-note">
  <div class="modal-header">
    <h6 class="modal-title pull-left">{{ title }}</h6>
    <button type="button" class="close pull-right" aria-label="Close" (click)="decline()" id="confirm-modal-closeBtn">
      <em class="icon-close"></em>
    </button>
  </div>
  <div class="modal-history-header mb-3">
    <span>{{ historyHeader }}</span>
  </div>
  <div class="modal-body history-modal-body pt-0">
    <div class="row sticky-top">
      <div class="col-4 history-list-header">Note Date</div>
      <div class="col-4 history-list-header">Comment</div>
      <div class="col-4 history-list-header">Note By</div>
    </div>
    <ng-container *ngIf="detailsList && detailsList.length; else noData">
      <div class="row" *ngFor="let detail of detailsList; index as i" [ngClass]="{ 'mt-2': i !== 0 }">
        <div class="col-4 history-list-text">
          {{ detail.createdDate | amFromUtc | amLocal | dateDisplay: dateTimeDisplay }}
        </div>
        <div class="col-4 history-list-text history-note-text">
          {{ detail.note }}
        </div>
        <div class="col-4 history-list-text">
          {{ detail.createdBy }}
        </div>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="row">
        <div class="col-4 history-list-text">-</div>
        <div class="col-4 history-list-text">-</div>
        <div class="col-4 history-list-text">-</div>
      </div>
    </ng-template>
  </div>
</div>
